import { Box, Grid } from '@material-ui/core';
import React from 'react';
import {
  CustomSwitchWithText,
  FeatureCard,
  SectionTitle
} from '../components/common';
import useStyles from '../styles';

// Các switch gọi API ngay khi xác nhận (không đi qua nút "Lưu lại")
export default function SystemSettingsSection({
  isCarType,
  isMAGType,
  settings
}) {
  const classes = useStyles();
  const {
    configAlert,
    configAutoUpdateMaxSpeed,
    accStatus,
    loading,
    onToggleSound,
    onToggleAutoUpdateMaxSpeed,
    onToggleAccStatus
  } = settings;

  return (
    <Box className={classes.sectionCard}>
      <SectionTitle
        title="Cài đặt hệ thống"
      />
      <Grid container spacing={2}>
        {isCarType && (
          <Grid item md={4} sm={6} xs={12}>
            <FeatureCard title="Cấu hình âm thanh cảnh báo">
              <CustomSwitchWithText
                checked={configAlert}
                onChange={onToggleSound}
                name="configAlert"
                disabled={loading}
              />
            </FeatureCard>
          </Grid>
        )}

        <Grid item md={4} sm={6} xs={12}>
          <FeatureCard
            title="Tự động giới hạn tốc độ"
            badge="BETA"
            badgeTone="warning"
          >
            <CustomSwitchWithText
              checked={configAutoUpdateMaxSpeed}
              onChange={onToggleAutoUpdateMaxSpeed}
              name="configAutoUpdateMaxSpeed"
              disabled={loading}
            />
          </FeatureCard>
        </Grid>

        {!isMAGType && (
          <Grid item md={4} sm={6} xs={12}>
            <FeatureCard title="Cấu hình ACC">
              <CustomSwitchWithText
                checked={accStatus}
                onChange={onToggleAccStatus}
                name="acc_status"
                disabled={loading}
              />
            </FeatureCard>
          </Grid>
        )}

      </Grid>
    </Box>
  );
}
